import { Component } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { HeaderService } from '@app/core/services/header.service';
import {
  chargeinformationBusinesstransactionsActionMenu
} from '@views/chargeInformation/chargeinformation-businesstransactions/chargeinformation-businesstransactions.actions-menu';
import { BusinessTransactionDto, BusinessTransactionService, ChargeInformationService } from '@app/api/dmc';
import { TableConfig } from '@shared/interfaces/table/table-config';
import {
  chargeinformationBusinesstransactionsTable
} from '@shared/table-configs/chargeinformation/chargeinformations-businesstransactions';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { TableComponent } from '@shared/components/table/table.component';
import {
  ShowBusinesstransactionModalComponent
} from '@shared/modals/meteringpoint/businesstransactions/show-businesstransaction-modal/show-businesstransaction-modal.component';

@Component({
  selector: 'app-chargeinformation-businesstransactions',
  imports: [
    TableComponent
  ],
  templateUrl: './chargeinformation-businesstransactions.component.html',
  styleUrl: './chargeinformation-businesstransactions.component.css'
})
export class ChargeinformationBusinesstransactionsComponent {
  public id?: string;
  public tableData: BusinessTransactionDto[] = [];
  public chargeInformationBusinesstransactionsTableConfig: TableConfig<BusinessTransactionDto> = chargeinformationBusinesstransactionsTable;

  public selectedElements: BusinessTransactionDto[] = [];

  constructor(
    private readonly modalService: ModalService,
    private readonly headerMenuService: HeaderService,
    private readonly route: ActivatedRoute,
    private readonly chargeInformationService: ChargeInformationService,
    private readonly businessTransactionService: BusinessTransactionService,
  ) {
    this.headerMenuService.setActions(chargeinformationBusinesstransactionsActionMenu, {
        show: () => this.openShowModal()
      },
      {
        show: () => this.selectedElements.length !== 1
      });
    this.route.parent?.paramMap.subscribe((q: ParamMap) => {
      this.id = q.get('id')!;
      this.chargeInformationService.chargeInformationGetByIdGet(this.id).subscribe(data => {
        if (data.chargeTypeId && data.chargeType) {
          this.businessTransactionService.businessTransactionGetBusinessTransactionsChargeInformationGet(data.chargeTypeId, data.chargeType).subscribe(results => {
            this.tableData = results;
          });
        }
      })
    });
  }

  public openShowModal(): void {
    this.modalService.show({
      title: 'common.show',
      component: ShowBusinesstransactionModalComponent,
      actions: [
        {
          type: 'primary',
          label: 'system.button.close',
          closeOnClick: true
        }
      ],
      params: {
        id: this.selectedElements[0]?.id,
        type: "chargeinformation"
      }
    })
  }
}
